import React from "react";

const FlashSlash = () => (
  <svg
    width="1.33rem"
    height="1.33rem"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.35498 10.5234V11.9467C5.35498 12.9267 5.88581 13.125 6.53331 12.39L10.9491 7.37336C11.4916 6.76086 11.2641 6.25336 10.4416 6.25336H9.89915"
      stroke="#7E858F"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.64508 5.15665V2.05331C8.64508 1.07331 8.11425 0.874981 7.46675 1.60998L3.05092 6.62665C2.50842 7.23915 2.73592 7.74665 3.55842 7.74665H5.36091V8.43498"
      stroke="#7E858F"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8334 1.16669L1.16675 12.8334"
      stroke="#7E858F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FlashSlash;
